import { Environment } from './models';

// Runtime config: populated by `assets/runtime-config.js`, which is generated
// at container startup by docker/runtime-config.sh from env vars. One Docker
// image runs in every environment — no per-env builds.
declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Environment;
  }
}

export const environment: Environment = (window.__RUNTIME_CONFIG__ ??
  {}) as Environment;
